import { Icons } from "@jod/ui";
import { useT } from "../i18n/index.ts";
import { useConnectivityStatus } from "./connectivity-store.ts";

/**
 * Global, non-blocking degraded/offline banner (FR-OFF-002). Disappears on
 * recovery to `online`. Deliberately not dismissible while `degraded`/
 * `offline` — the requirement is "no dismiss while offline for money-moving
 * screens"; since this banner is app-wide and non-blocking (it never
 * prevents interaction with the screen underneath), we keep that rule
 * uniform rather than threading a per-route "is this a money screen" flag
 * through for this MVP pass.
 */
export function ConnectivityBanner() {
  const t = useT();
  const status = useConnectivityStatus();

  if (status === "online") return null;

  const isOffline = status === "offline";

  return (
    <div
      role="status"
      data-testid="connectivity-banner"
      data-status={status}
      className="jod-fade-up fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-2 px-4 py-2 text-center text-xs"
      style={{
        paddingTop: "calc(0.5rem + env(safe-area-inset-top))",
        background: isOffline ? "oklch(58% 0.18 25 / 92%)" : "oklch(79% 0.12 80 / 92%)",
        color: isOffline ? "oklch(97% 0.01 25)" : "oklch(18% 0.02 80)",
      }}
    >
      {isOffline ? <Icons.IconLock size={14} /> : <Icons.IconEye size={14} />}
      <span>{isOffline ? t("connectivity.offline") : t("connectivity.degraded")}</span>
    </div>
  );
}
